export const defaultTicketsSentEarliestDays = 3;
export const defaultTicketsSentLatestDays = 1;
